import { render, staticRenderFns } from "./TicketCreateContainer.vue?vue&type=template&id=0edcc6f1"
import script from "./TicketCreateContainer.vue?vue&type=script&lang=js"
export * from "./TicketCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./TicketCreateContainer.vue?vue&type=style&index=0&id=0edcc6f1&prod&scoper=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports